/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Stats_Scope_SortingInputs */

const vi_warehouse_stats_scope_sorting = /** @type {(inputs: Warehouse_Stats_Scope_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô phân loại`)
};

/**

* @param {Warehouse_Stats_Scope_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_stats_scope_sorting = /** @type {((inputs?: Warehouse_Stats_Scope_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Stats_Scope_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_stats_scope_sorting(inputs)
});